
<template>
  <v-card
    class="py-12 d-flex flex-column justify-center"
    tile
    elevation="0"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '300px'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <div v-if="settings.title.content || settings.subtitle.content" class="pb-12">
      <title-component :id="id" :settings="{...settingsTitle, idLayout: settings.idLayout}" />
    </div>

    <div class="div-style">
      <v-row class="mx-12" no-gutters justify="center" align="center" style="max-width: 1340px">
        <v-col
          v-for="(item, i) in settings.items"
          :key="i"
          :cols="$vuetify.breakpoint.mdAndUp ? 12 / settings['max-columns'] : '6'"
          align="center"
          :class="[
            {'pb-8': !$vuetify.breakpoint.mdAndUp && isPaddingBottomNecessary(i, settings.items.length)},
            {'pb-8': $vuetify.breakpoint.mdAndUp && isPaddingBottomNecessary(i, settings.items.length, settings['max-columns'])}
          ]"
        >
          <v-row no-gutters justify="center">
            <h1 :style="`color: ${settings['accent-color']}`">
            {{ item.number }}
            </h1>
          </v-row>

          <v-row class="mt-1" no-gutters justify="center">
            <b 
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
                color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
                `
              "
            >
              {{item.description}}
            </b>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import TitleComponent from "../title/TitleComponent.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent },
  props: {
    id: {type: String},
    settings: {
      type: Object,
    },
  },

  data() {
    return {
      settingsTitle: null,
      hover: false,
    };
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },

  methods: {
    isPaddingBottomNecessary (index, totalItems, rowItems) {
      const itemsByRow = rowItems || 2
      const paddingObjValue = []
      let indexes = []

      for (let i = 0; i < totalItems; i++) {
        indexes.push(i) 
        if (indexes.length === itemsByRow) {
          paddingObjValue.push(indexes)
          indexes = []
        }
      }

      if (indexes.length > 0) paddingObjValue.push(indexes)

      const lastPairValue = paddingObjValue[paddingObjValue.length - 1]
      return lastPairValue.includes(index) ? false : true
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0px;
  text-align: center;
}

b {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
  text-align: center;
}

.div-style {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>